const showMenu = document.getElementById('showMenu');
const closeMenu = document.getElementById('closeMenu');
const mainMenu = document.getElementById('mainMenu');
const languageSwitcher = document.getElementById('languageSwitcher');

showMenu?.addEventListener('click', () => mainMenu?.classList.add('open'));
showMenu?.addEventListener('click', () => languageSwitcher?.classList.add('open'));
closeMenu?.addEventListener('click', () => mainMenu?.classList.remove('open'));
closeMenu?.addEventListener('click', () => languageSwitcher?.classList.remove('open'));

const mainHeader = document.querySelector('.main-header');
if (mainHeader) {
    window.addEventListener('scroll', () => {
        mainHeader.classList.toggle('minus', window.scrollY > 60);
    }, {passive: true});
}